import * as React from "react";
const SvgFiRrPaintBrush = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-paint-brush_svg__a)">
      <path
        fill="#062147"
        d="M23.1.9a3.14 3.14 0 0 0-4.33 0L7.563 12.1a5.6 5.6 0 0 0-1.058-.1 5.46 5.46 0 0 0-3.885 1.61C1.268 14.961.314 18.591.031 20.562a3 3 0 0 0 3.408 3.406c1.971-.283 5.6-1.237 6.954-2.589a5.5 5.5 0 0 0 1.5-4.94L23.1 5.23a3.07 3.07 0 0 0 0-4.33M8.977 19.966c-.725.725-3.5 1.69-5.824 2.023a1.02 1.02 0 0 1-.859-.283 1 1 0 0 1-.282-.859c.333-2.323 1.3-5.1 2.022-5.824a3.5 3.5 0 0 1 4.943 4.943m12.711-16.15L11.067 14.438a5.4 5.4 0 0 0-1.5-1.508L20.184 2.312a1.086 1.086 0 0 1 1.5 0 1.06 1.06 0 0 1 .004 1.504"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-paint-brush_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPaintBrush;
